import request from '@/utils/request'

export function getCurrent(params) {
    return request({
        url: '/user/userInfo',
        method: 'get',
        params
    })
}
